import React, { useState, useEffect } from "react";
import { producaov2 as api } from "../../../../services/apis";
import { Button } from "semantic-ui-react";
import * as yup from "yup";

import { Container, Content, Title, Input } from "./styles";

import swal from "sweetalert";
import { withRouter } from "react-router-dom";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";

import { isAuthAdmin } from "../../../../services/auth";
import { AlunoSearchInput } from "../../../../components/Admin/AlunoSearchInput";

const InserirVoittoCoins = () => {
  const [voittoCoins, setVoittoCoins] = useState({
    id_pessoa: "",
    quantidade: "",
    senha: "",
    reason: "",
  });

  useEffect(() => {
    loadAuth();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const inserir = async () => {
    const vtsValidation = await yup.object().shape({
      id_pessoa: yup
        .string("Necessário que informe o id do aluno")
        .required("Necessário que informe o id do aluno"),
      quantidade: yup
        .number("Necessário que informe a quantidade de VoittoCoins")
        .required("Necessário que informe a quantidade de VoittoCoins"),
      senha: yup
        .string("Necessário que informe a senha")
        .required("Necessário que informe a senha"),
      reason: yup
        .string("Necessário que informe o motivo")
        .required("Necessário que informe o motivo"),
    });

    try {
      await vtsValidation.validate(voittoCoins, { abortEarly: true });
      api
        .post(`/admin/atribuir/voittocoins`, voittoCoins)
        .then(res => {
          if (res.data == "Senha Incorreta") {
            swal("Senha Incorreta", "", "error");
          } else {
            let logs = {
              local: "alunos/vts",
              texto: `inseriu voittoCoins para o id=${voittoCoins.id_pessoa}`,
            };
            api.post("system_logs", { acao: JSON.stringify(logs) });
            swal("VoittoCoins inserido com sucesso", "", "success");
          }
        })
        .catch(err => {
          swal("Não foi possível salvar os voittocoins", err, "");
        });
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        swal("Erro!", `${err}`, "error");
        return;
      }
    }
  };

  return (
    <>
      <Container>
        <AdminMenu />

        <Content>
          <Title>Inserir VoittoCoins</Title>
          <div>
            <label>ID Aluno:</label>
            <AlunoSearchInput
              hideLabel
              handleChange={e => setVoittoCoins({ id_pessoa: e.id })}
            />
            <label>Quantidade:</label>
            <Input
              placeholder="Digite a quantidade de VoittoCoins à ser atribuída ao aluno. Ex: 500"
              type="number"
              onChange={e =>
                setVoittoCoins({ ...voittoCoins, quantidade: e.target.value })
              }
            />
            <label>Motivo:</label>
            <Input
              placeholder="Digite o motivo da atribuição"
              onChange={e =>
                setVoittoCoins({ ...voittoCoins, reason: e.target.value })
              }
            />
            <label>Senha:</label>
            <Input
              type="password"
              onChange={e =>
                setVoittoCoins({ ...voittoCoins, senha: e.target.value })
              }
            />
            <Button color="orange" onClick={inserir}>
              Inserir VoittoCoins
            </Button>
          </div>
        </Content>
      </Container>
    </>
  );
};

export default withRouter(InserirVoittoCoins);
